import AiServiceV2 from '../../../services/v2/AiServiceV2';
import aiUseCaseV2 from './aiUseCaseV2';

const aiFactoryV2 = aiUseCaseV2({
  AiServiceV2: AiServiceV2(),
});

export default aiFactoryV2;
